var _path, _g, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_128678",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0004 2.00024H21.96V21.95H2.0004V2.00024Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_128678)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6504 3.5C5.1294 3.5 3.5004 5.227 3.5004 7.899V16.051C3.5004 18.724 5.1294 20.45 7.6504 20.45H16.3004C18.8274 20.45 20.4604 18.724 20.4604 16.051V7.899C20.4604 5.227 18.8274 3.5 16.3004 3.5H7.6504ZM16.3004 21.95H7.6504C4.2704 21.95 2.0004 19.579 2.0004 16.051V7.899C2.0004 4.371 4.2704 2 7.6504 2H16.3004C19.6854 2 21.9604 4.371 21.9604 7.899V16.051C21.9604 19.579 19.6854 21.95 16.3004 21.95Z",
    fill: "#D9DCDF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28141 17.1805C5.09541 17.1805 4.91041 17.1125 4.76541 16.9745C4.46441 16.6905 4.45241 16.2145 4.73741 15.9155L6.26541 14.3025C7.07441 13.4435 8.43941 13.4015 9.30241 14.2115L10.2604 15.1835C10.5274 15.4535 10.9614 15.4585 11.2294 15.1945C11.3304 15.0755 13.5084 12.4305 13.5084 12.4305C13.9224 11.9285 14.5064 11.6185 15.1554 11.5545C15.8054 11.4975 16.4364 11.6865 16.9394 12.0995C16.9824 12.1345 17.0214 12.1685 19.2174 14.4235C19.5064 14.7195 19.5014 15.1945 19.2044 15.4835C18.9084 15.7745 18.4324 15.7655 18.1434 15.4695C18.1434 15.4695 16.0944 13.3665 15.9484 13.2245C15.7934 13.0975 15.5444 13.0235 15.2994 13.0475C15.0504 13.0725 14.8264 13.1915 14.6674 13.3845C12.3434 16.2035 12.3154 16.2305 12.2774 16.2675C11.4194 17.1095 10.0344 17.0955 9.19141 16.2355C9.19141 16.2355 8.26141 15.2915 8.24541 15.2725C8.01441 15.0585 7.60241 15.0725 7.35541 15.3335L5.82541 16.9465C5.67741 17.1025 5.47941 17.1805 5.28141 17.1805Z",
    fill: "#D9DCDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5576 8.12891C8.0046 8.12891 7.5546 8.57891 7.5546 9.13291C7.5546 9.68691 8.0046 10.1379 8.5586 10.1379C9.1126 10.1379 9.5636 9.68691 9.5636 9.13291C9.5636 8.57991 9.1126 8.12991 8.5576 8.12891ZM8.5586 11.6379C7.1776 11.6379 6.0546 10.5139 6.0546 9.13291C6.0546 7.75191 7.1776 6.62891 8.5586 6.62891C9.9406 6.62991 11.0636 7.75391 11.0636 9.13291C11.0636 10.5139 9.9396 11.6379 8.5586 11.6379Z",
    fill: "#D9DCDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImageIcon);
export default __webpack_public_path__ + "static/media/addImageIcon.a7e13f7a8e8d48e699e66d5d95f4ddc3.svg";
export { ForwardRef as ReactComponent };